import { useCallback, useState } from 'react';

import CameraConnection from 'src/models/Camera/CameraConnection';
import { GetSettingsResponse } from 'src/models/Camera/Settings/GetSettings.model';

import { captureError } from 'src/utils/errorReporting';

export function useGetCameraSettings() {
  const [cameraSettings, setCameraSettings] = useState<GetSettingsResponse>();

  const [isGettingCameraSettings, setIsGettingSettings] = useState(false);

  const getCameraSettings = useCallback(async () => {
    try {
      setIsGettingSettings(true);
      const response = await CameraConnection.getInstance().getSettings();
      setCameraSettings(response.data);
    } catch (error) {
      captureError(error, 'Failed to get camera settings');

      // TODO: Uncomment this after we receive the error message from the translation company
      // Api.alertBox({
      //   title: t('bootbox.title.Error', { ns: I18NextNS.COMMON }),
      //   message: t('message.error.failedToGetCameraSettings', {
      //     ns: I18NextNS.COMMON,
      //   }),
      //   locale: language,
      //   type: 'error',
      // });
    } finally {
      setIsGettingSettings(false);
    }
  }, []);

  return {
    getCameraSettings,
    isGettingCameraSettings,
    cameraSettings,
    setCameraSettings,
  };
}
